import {useAuth} from '@apps-common/auth-react';
import AppsDropdown from '@apps-common/ui-components/NavBar/AppsDropdown.jsx';
import NavBar, {HelpMenu} from '@apps-common/ui-components/NavBar/index.js';
import {Button, styled} from '@mui/material';
import React, {useCallback} from 'react';
import {Link} from 'react-router';
import {DEPLOY_ENV, ENVS} from '../../config.js';
import NavItem from './nav-item.jsx';

const Navigation = styled('nav')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  margin: theme.spacing(0, 1),
}));

export default function Header() {
  const auth = useAuth();

  const login = useCallback(() => auth.signIn(), [auth]);
  const logout = useCallback(() => {
    analytics.track('Logout Button clicked');
    auth.signOut();
  }, [auth]);

  const Nav = (
    <Navigation>
      <NavItem to="/" data-cy="nav-item-browse">
        Browse
      </NavItem>

      {auth.user && (
        <NavItem to="/my-stories" data-cy="nav-item-my-stories">
          My stories
        </NavItem>
      )}

      <Button
        to="/create"
        component={Link}
        color="primary"
        data-cy="nav-item-create"
        size="small"
        sx={{
          display: {xs: 'none', sm: 'block'},
          padding: theme => theme.spacing(0.25, 1),
        }}
        variant="contained"
      >
        Create
      </Button>
    </Navigation>
  );

  const environment =
    DEPLOY_ENV === ENVS.production ? ENVS.production : ENVS.staging;

  return (
    <div className="pl-mode-dark">
      <NavBar
        title={<AppsDropdown appKey="stories" environment={environment} />}
        environment={environment}
        user={auth.user?.claims}
        logout={logout}
        login={login}
        position="sticky"
        secondary={
          <>
            {Nav}
            <HelpMenu />
          </>
        }
      />
    </div>
  );
}
